export default (elevatedSection) => {
	const pathname = window.location.pathname.substr(1);
	const firstSlashIndex = pathname.indexOf('/');
	const activeSection = firstSlashIndex > -1 ? pathname.substr(0, firstSlashIndex) : pathname;
	return activeSection === elevatedSection ? 'selected' : '';
};
